import { render, staticRenderFns } from "./UiLink.vue?vue&type=template&id=0ba77278"
import script from "./UiLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports